var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"save__btn",attrs:{"variant":_vm.variant},on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":"save"}}),_vm._v("\n\t"+_vm._s(_vm.$t(_vm.label))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }